module.exports = __webpack_public_path__ + "img/card_bj@3x.97a02ea3.png";